import styled from 'styled-components';

export const GoalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
